import Axios from 'axios'
import Cookies from 'js-cookie'
import { API_TIMEOUT, VERSION_KEY } from '@/constants'

export function createConfigWithCsrfToken() {
  const csrftoken = Cookies.get('csrftoken')
  const config = csrftoken ? { headers: { 'X-CSRFToken': csrftoken } } : null
  return config
}

function createAxios() {
  const axios = Axios.create({ baseURL: '/api/', timeout: API_TIMEOUT })
  axios.interceptors.response.use(
    function(response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      const currentVersion = localStorage.getItem(VERSION_KEY)
      const newVersion = response.headers[VERSION_KEY]
      if (newVersion !== currentVersion) {
        localStorage.setItem(VERSION_KEY, newVersion)
        // eslint-disable-next-line
        console.log(
          `Reloading page to upgrade from version ${currentVersion} to version ${newVersion}`
        )
        location.reload(true)
      }
      return response
    },
    function(error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      return Promise.reject(error)
    }
  )
  return axios
}

export const configuredAxios = createAxios()

export default {
  axios: createAxios(),
  // GET
  getUser() {
    return this.axios.get('current-user/')
  },
  getAction(Id) {
    return this.axios.get(`actions/${Id}/`)
  },
  getActionTemplates() {
    return this.axios.get('action-templates/')
  },
  // POST
  // TODO RENAME to postAction
  addAction(action) {
    return this.axios.post('actions/', action, createConfigWithCsrfToken())
  },
  postMultipleActions(actions) {
    return this.axios.post(
      'actions/multiple/',
      actions,
      createConfigWithCsrfToken()
    )
  },
  // PUT
  updateAction(id, action) {
    return this.axios.put(`actions/${id}/`, action, createConfigWithCsrfToken())
  },
  // DELETE
  deleteAction(id) {
    return this.axios.delete(`actions/${id}/`, createConfigWithCsrfToken())
  }
}

export const reports = {
  axios: Axios.create({ timeout: API_TIMEOUT }),
  // GET
  getReport(url) {
    return this.axios.get('/api/reports/' + url)
  },
  getFileReport(url) {
    return this.axios.get('/api/reports/' + url, { responseType: 'blob' })
  }
}
